import React from 'react';
interface CreditNoteFooterProps {
  preparedBy: string;
}
export function CreditNoteFooter({
  preparedBy
}: CreditNoteFooterProps) {
  return <div className="space-y-6" data-id="element-191">
      {/* Prepared By Section */}
      <div className="grid grid-cols-2 gap-6" data-id="element-192">
        <div data-id="element-193">
          <p className="text-xs font-semibold text-neutral-700 mb-3" data-id="element-194">
            Prepared by:
          </p>
          <div className="border-b-2 border-neutral-300 pb-1 mb-2 h-12 flex items-end" data-id="element-195">
            <span className="text-xs text-neutral-900" data-id="element-196">{preparedBy}</span>
          </div>
          <p className="text-xs text-neutral-500" data-id="element-197">Signature</p>
        </div>

        <div data-id="element-198">
          <p className="text-xs font-semibold text-neutral-700 mb-3" data-id="element-199">E.&O.E.</p>
          <p className="text-xs text-neutral-600 leading-relaxed" data-id="element-200">
            Errors and Omissions Excepted
          </p>
        </div>
      </div>

      {/* Footer Note */}
      <p className="text-xs text-neutral-500 italic text-center pt-4 border-t border-neutral-200" data-id="element-201">
        This is a computer-generated document. No signature is required.
      </p>
    </div>;
}